import { LockedFeatureEmptyState } from '../../../../../components/locked-feature-empty-state/locked-feature-empty-state';
import PurchaseOrderIcon from '../../../../../svgs/purchase-order.svg';
import { transferOrderEmptyStateMessages } from './transfer-order-empty-state.messages';

type TransferOrderEmptyStateProps = {
  view: {
    id: string;
    buttons: React.ReactElement[];
    label: React.ReactElement | string;
  };
};

export const TransferOrderEmptyState = ({ view }: TransferOrderEmptyStateProps) => (
  <LockedFeatureEmptyState icon={PurchaseOrderIcon} messages={transferOrderEmptyStateMessages} view={view} />
);
